import React from 'react';
import Slick from 'react-slick';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';
import './style/index.scss';
class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slickGoToIndex: props.slickGoToIndex || -1
    }
  }
  componentDidMount() {
    if (this.props.slickGoToIndex !== -1) {
      setTimeout(() => {
        this._slick.slickGoTo(this.props.slickGoToIndex);
      }, 200);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps && nextState && nextProps.slickGoToIndex != '' && nextState.slickGoToIndex != '' && nextProps.slickGoToIndex != nextState.slickGoToIndex) {
      this.setState({
        slickGoToIndex: nextProps.slickGoToIndex
      })
      return true;
    }
    return false;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.slickGoToIndex !== -1) {
      this._slick.slickGoTo(this.props.slickGoToIndex);
    }
  }

  render() {
    const displayName = 'banner';
    const {
      children,
      autoplay,
      centerMode,
      dots,
      afterChange,
      beforeChange,
      infinite,
      adaptiveHeight,
      initialSlideIndex,
      slickGoToIndex,
      slidesToShow,
      slidesToScroll,
      centerPadding,
      vertical,
      onSwipe,
    } = this.props;

    return (
      <div
        className={this.className(bem(displayName))}
        style={this.style()}
        {...getDataAttr(this.props)}>
        <Slick ref={function (c) { this._slick = c }.bind(this)}
          arrows={false}
          autoplay={autoplay}
          centerMode={centerMode}
          dots={dots}
          afterChange={afterChange}
          beforeChange={beforeChange}
          infinite={infinite}
          adaptiveHeight={adaptiveHeight}
          initialSlide={initialSlideIndex}
          touchThreshold={10}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          centerPadding={centerPadding}
          vertical={vertical}
          onSwipe={onSwipe}
        >
          {children}

        </Slick>
      </div>
    );
  }
}

Banner.defaultProps = {
  children: null,
  autoplay: true,
  centerMode: false,
  dots: true,
  infinite: true,
  adaptiveHeight: false,
  initialSlideIndex: 0,
  slickGoToIndex: -1,
  afterChange: () => { },
  beforeChange: () => { },
  slidesToShow: 1,
  slidesToScroll: 1,
};

Banner.propTypes = {
  // @INTRO 添加按钮内容
  children: PropTypes.node,
  // @INTRO 是否自动播放
  autoplay: PropTypes.bool,
  // @INTRO 是否开启居中模式
  centerMode: PropTypes.bool,
  // @INTRO 是否显示指示点
  dots: PropTypes.bool,
  // @INTRO 是否循环
  infinite: PropTypes.bool,
  // @INTRO 各个卡片是否自调节高度
  adaptiveHeight: PropTypes.bool,
  // @INTRO 组件构建时默认展示哪一个slide
  initialSlideIndex: PropTypes.number,
  // @INTRO 组件构建完跳转到哪一个slide
  slickGoToIndex: PropTypes.number,
  // @INTRO 切换banner 的回调
  afterChange: PropTypes.func,
  // @INTRO 切换banner 的回调
  beforeChange: PropTypes.func,
  // @INTRO 显示几个选项面板
  slidesToShow: PropTypes.number,
  // @INTRO 一次滚动几个
  slidesToScroll: PropTypes.number,
};

export default Banner;
